import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL kept alive: the unified XAU Terminal now lives at /dashboard.
export const Route = createFileRoute("/_authenticated/dashboard/trading-room")({
  beforeLoad: () => {
    throw redirect({ to: "/dashboard", replace: true });
  },
});
